// App Imports
import pincode from "../modules/pincode/api/routes";
import banner from "../modules/banner/api/routes";
import broadcastmsg from "../modules/broadcastmsg/api/routes";
import feedback from "../modules/feedback/api/routes";
import reward from "../modules/rewards/api/routes";
import category from "../modules/category/api/routes";
import customer from "../modules/customer/api/routes";
import delivery from "../modules/delivery/api/routes";
import log from "../modules/log/api/routes";
import order from "../modules/order/api/routes";
import pages from "../modules/pages/api/routes";
import product from "../modules/product/api/routes";
import setting from "../modules/setting/api/routes";
import user from "../modules/user/api/routes";
import vendor from "../modules/vendor/api/routes";
import faq from "../modules/faq/api/routes";
import ratingFeedback from "../modules/ratingFeedback/api/routes";
import uberDelivery from "../modules/uberDelivery/api/routes";
import messaging from "../modules/marketing/api/routes";
import analytics from "../modules/analytics/api/routes";
import cms from "../modules/cms/api/routes";
import crm from "../modules/CRM/api/routes";
import qrCodeGenerator from "../modules/QRCodeGenerator/api/routes";
import intents from "../modules/intentManager/api/routes";
import teams from "../modules/roles/api/routes";
import tableBooking from "../modules/tableReservation/api/routes";
import googleCalendar from "../modules/googleCalendar/api/routes"
import mediaGallery from "../modules/mediaGallery/api/routes";
import qrDining from "../modules/qrDining/api/routes";
import documents from "../modules/documentManager/api/routes";
import engagementUsers from "../modules/engagementUsers/api/routes";

// Combined routes
const routes = {
  ...pages,
  ...user,
  ...customer,
  ...category,
  ...product,
  ...pincode,
  ...vendor,
  ...order,
  ...banner,
  ...setting,
  ...delivery,
  ...broadcastmsg,
  ...feedback,
  ...log,
  ...reward,
  ...faq,
  ...ratingFeedback,
  ...uberDelivery,
  ...analytics,
  ...messaging,
  ...cms,
  ...crm,
  ...qrCodeGenerator,
  ...teams,
  ...intents,
  ...tableBooking,
  ...googleCalendar,
  ...mediaGallery,
  ...qrDining,
  ...documents,
  ...engagementUsers,
};

export default routes;